$("body.in-index .carousel-inner").slick({
  slidesToShow: 4.75,
  slidesToScroll: 1,
  centerMode: false,
  autoplay: false,
  dots: false,
  arrows: true,
  infinite: false,
  adaptiveHeight: false,
  responsive: [
    {
      breakpoint: 1200,
      settings: { slidesToShow: 3, slidesToScroll: 1 },
    },
    {
      breakpoint: 991,
      settings: { slidesToShow: 2, slidesToScroll: 1 },
    },
    {
      breakpoint: 550,
      settings: {
        slidesToShow: 1,
        variableWidth: true,
      },
    },
  ],
});
$("body.in-index .products-block, .type-detail .products-block").slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  centerMode: false,
  autoplay: false,
  autoplaySpeed: 5000,
  dots: true,
  arrows: true,
  infinite: false,
  adaptiveHeight: false,
  responsive: [
    {
      breakpoint: 1200,
      settings: { slidesToShow: 3, slidesToScroll: 1 },
    },
    {
      breakpoint: 991,
      settings: { slidesToShow: 2, slidesToScroll: 1 },
    },
    {
      breakpoint: 550,
      settings: {
        slidesToShow: 1,
        variableWidth: true,
      },
    },
  ],
});
